import { useState, useEffect } from 'react';
import { supabase } from '../supabaseclient';

export default function RelatorioEnxoval() {
  const [registros, setRegistros] = useState([]);
  const [busca, setBusca] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    buscarDados();
  }, []);

  const buscarDados = async () => {
    setLoading(true);
    const { data } = await supabase
      .from('Kit_enxoval')
      .select('*')
      .order('created_at', { ascending: false });
    
    if (data) setRegistros(data);
    setLoading(false);
  };

  // Filtro de busca aprimorado (Nome, Endereço ou Telefone)
  const dadosFiltrados = registros.filter(r => 
    r.Beneficiario?.toLowerCase().includes(busca.toLowerCase()) ||
    r.Endereco?.toLowerCase().includes(busca.toLowerCase()) ||
    r.Telefone?.includes(busca)
  );

  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <div>
          <h2 className="text-xl font-black text-blue-900 uppercase">Relatório de Enxovais</h2>
          <p className="text-[10px] text-gray-400 font-bold uppercase">Lista de gestantes atendidas</p>
        </div>
        
        <div className="flex gap-2 w-full md:w-auto">
          <input 
            type="text"
            placeholder="🔍 Buscar nome, rua ou tel..."
            className="p-3 bg-white border-none shadow-sm rounded-xl text-xs font-bold w-full md:w-80"
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
          />
          <button 
            onClick={buscarDados}
            className="bg-blue-100 text-blue-900 p-3 rounded-xl hover:bg-blue-200 transition-all shadow-sm"
            title="Atualizar dados"
          >
            🔄
          </button>
        </div>
      </div>

      <div className="bg-white rounded-[2rem] shadow-xl overflow-hidden border border-gray-100">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-blue-900 text-white">
                <th className="p-5 text-[10px] font-black uppercase tracking-widest">Data</th>
                <th className="p-5 text-[10px] font-black uppercase tracking-widest">Beneficiária</th>
                <th className="p-5 text-[10px] font-black uppercase tracking-widest">Sexo</th>
                <th className="p-5 text-[10px] font-black uppercase tracking-widest">Telefone</th>
                <th className="p-5 text-[10px] font-black uppercase tracking-widest text-center">Ações</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {loading ? (
                <tr><td colSpan="5" className="p-10 text-center text-gray-400 font-bold italic">Carregando...</td></tr>
              ) : dadosFiltrados.length > 0 ? (
                dadosFiltrados.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                    <td className="p-5 text-xs font-bold text-gray-400">
                      {new Date(item.created_at).toLocaleDateString('pt-BR')}
                    </td>
                    <td className="p-5">
                      <p className="text-sm font-black text-blue-900 uppercase leading-none mb-1">{item.Beneficiario}</p>
                      <p className="text-[10px] text-gray-400 font-bold truncate max-w-xs">{item.Endereco}</p>
                    </td>
                    <td className="p-5">
                      <span className={`px-3 py-1 rounded-full text-[9px] font-black uppercase shadow-sm ${
                        item.Sexo_Bebe === 'Masculino' ? 'bg-blue-100 text-blue-700' : 'bg-pink-100 text-pink-700'
                      }`}>
                        {item.Sexo_Bebe}
                      </span>
                    </td>
                    <td className="p-5 text-xs font-bold text-gray-600">{item.Telefone}</td>
                    <td className="p-5 text-center">
                      <a 
                        href={`https://wa.me{item.Telefone?.replace(/\D/g, '')}`} 
                        target="_blank" 
                        rel="noreferrer"
                        className="bg-green-100 text-green-600 px-4 py-2 rounded-xl hover:bg-green-600 hover:text-white transition-all text-[10px] font-black inline-block shadow-sm"
                      >
                        WHATSAPP
                      </a>
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="5" className="p-10 text-center text-gray-400 font-bold italic">Nenhum registro encontrado.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
